var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.813 2.75h12.833M4.813 19.25h12.833m-1.604-16.5v2.338a3 3 0 0 1-.674 1.894l-2.58 3.167a1.504 1.504 0 0 0 .027 1.943l2.502 2.91a3 3 0 0 1 .725 1.955v2.293M6.417 2.75v2.338a3 3 0 0 0 .673 1.894l2.58 3.167a1.504 1.504 0 0 1-.027 1.943l-2.501 2.91a3 3 0 0 0-.725 1.955v2.293"
  })));
};
export default SvgHourglass;